export default "__VITE_ASSET__7fe82943__"